/**
 * Pasos de `phase` con la numeración global ("N / total") del recorrido.
 * `sequence` es una lista ordenada de [phaseKey, steps]. Devuelve [] si la fase no está.
 */
export const numberPhaseSteps = (sequence, phase) => {
  const globalTotal = sequence.reduce((sum, [, steps]) => sum + steps.length, 0);
  let globalOffset = 0;
  for (const [phaseKey, steps] of sequence) {
    if (phaseKey === phase) {
      return steps.map((step, i) => ({
        ...step,
        globalStep: globalOffset + i + 1,
        globalTotal,
      }));
    }
    globalOffset += steps.length;
  }
  return [];
};
